import { useCallback } from 'react';
import { ProjectTypeEnum } from '~/api/types';
import { getPriviligies } from '~/utils';

export enum ProjectTabsEnum {
  PROJECT_DETAILS_TAB = 'Project Details',
  ETL_JOBS_TAB = 'ETL Jobs',
  WORKBENCH_TAB = 'Workbench',
  PROJECT_MEMBERS_TAB = 'Project Members',
  MODELS_TAB = 'Models',
  INSTRUCTIONS_TAB = 'Instructions For Use',
  EXT_RESOURCES_TAB = 'External Resources',
  STUDIO_INTEGRATION_TAB = 'Studio Integration',
}

type UserPrivileges = ReturnType<typeof getPriviligies>;

type UseProjectTabEnabledParams = {
  projectType?: ProjectTypeEnum;
  userApplicationPriviligies?: UserPrivileges;
  userProjectPriviligies?: UserPrivileges;
};

const useProjectTabEnabled = ({
  projectType,
  userApplicationPriviligies,
  userProjectPriviligies,
}: UseProjectTabEnabledParams) =>
  useCallback(
    (tabName: ProjectTabsEnum) => {
      switch (tabName) {
        case ProjectTabsEnum.PROJECT_DETAILS_TAB:
          return true;
        case ProjectTabsEnum.STUDIO_INTEGRATION_TAB:
          return (
            userApplicationPriviligies?.studioIntegrationTab.canView ||
            userProjectPriviligies?.studioIntegrationTab.canView
          );
        case ProjectTabsEnum.ETL_JOBS_TAB:
          return (
            projectType === ProjectTypeEnum.PRODUCER &&
            (userApplicationPriviligies?.etlJobsTab.canView || userProjectPriviligies?.etlJobsTab.canView)
          );
        case ProjectTabsEnum.WORKBENCH_TAB:
          return userApplicationPriviligies?.workbenchTab.canView || userProjectPriviligies?.workbenchTab.canView;
        case ProjectTabsEnum.PROJECT_MEMBERS_TAB:
          return (
            userApplicationPriviligies?.projectMembersTab.canView || userProjectPriviligies?.projectMembersTab.canView
          );
        default:
          return false;
      }
    },
    [projectType, userApplicationPriviligies, userProjectPriviligies],
  );

export default useProjectTabEnabled;
